// import clearance from './clearance'
import gear from 'html/desktop/mainmenu/bags&gear'
import home from 'html/desktop/mainmenu/home'
import kids from 'html/desktop/mainmenu/kids'
import men from 'html/desktop/mainmenu/men'
import outerwear from 'html/desktop/mainmenu/outerwear'
// import sale from 'html/desktop/mainmenu/sale'
import shopbyactivity from 'html/desktop/mainmenu/shopbyactivity'
import women from 'html/desktop/mainmenu/women'

export default {
  'Men': men,
  'Women': women,
  'Home': home,
  'Gear': gear,
  'Outerwear': outerwear,
  'Kids': kids,
  'Shop By Activity': shopbyactivity,
  // 'Sale': sale,
  // 'Clearance': clearance
}
